import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faLocationDot } from '@fortawesome/free-solid-svg-icons';
import RatingBadge from './RatingBadge';

interface NearbyAlternativeCardProps {
    shopId: string;
    name: string;
    distanceMeters: number;
    avgRating: number;
    ratingCount: number;
}

function formatDistance(meters: number): string {
    if (meters < 1000) return `${meters} m`;
    return `${(meters / 1000).toFixed(1)} km`;
}

const NearbyAlternativeCard: React.FC<NearbyAlternativeCardProps> = ({
    shopId,
    name,
    distanceMeters,
    avgRating,
    ratingCount
}) => {
    const navigate = useNavigate();

    return (
        <button
            type="button"
            onClick={() => navigate(`/coffeeshops/${shopId}`)}
            className="w-full text-left bg-paper border-brutal border-ink shadow-brutal-sm rounded-sm p-4 hover:translate-x-[1px] hover:translate-y-[1px] hover:shadow-sm transition-all flex items-center gap-3"
        >
            <div className="flex-1 min-w-0">
                <h3 className="text-base font-bold text-ink truncate">{name}</h3>
                <div className="flex items-center gap-2 mt-1 text-sm text-muted-foreground">
                    <FontAwesomeIcon icon={faLocationDot} className="text-xs" />
                    <span>{formatDistance(distanceMeters)}</span>
                    <span aria-hidden>·</span>
                    <span>{ratingCount} {ratingCount === 1 ? 'rating' : 'ratings'}</span>
                </div>
            </div>
            {ratingCount > 0 && <RatingBadge rating={avgRating} size="sm" />}
            <FontAwesomeIcon icon={faChevronRight} className="text-muted-foreground text-sm" />
        </button>
    );
};

export default NearbyAlternativeCard;
